(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-add-and-open]');
    if (!trigger) return;
    var variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    addAndOpen(trigger, variantId);
  });

  function addAndOpen(trigger, variantId) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || !window.routes || !routes.cart_add_url) {
      window.location.href = trigger.getAttribute('href') || '/cart';
      return;
    }

    var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
    var body = {
      id: Number(variantId),
      quantity: 1,
      sections: sectionIds,
      sections_url: window.location.pathname
    };

    trigger.classList.add('loading');

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var parsed = JSON.parse(text);
        if (parsed && parsed.status && parsed.status >= 400) {
          throw new Error(parsed.description || parsed.message || 'Cart error');
        }
        cart.getSectionsToRender().forEach(function (section) {
          var el = document.getElementById(section.id);
          if (!el || !parsed.sections || !parsed.sections[section.id]) return;
          var html = new DOMParser().parseFromString(parsed.sections[section.id], 'text/html');
          var inner = html.querySelector('#minicart-form');
          if (inner) el.innerHTML = inner.innerHTML;
          var countdown = cart.querySelector('.cart-countdown-time');
          var newCountdown = html.querySelector('.cart-countdown-time');
          if (countdown && newCountdown) countdown.innerHTML = newCountdown.innerHTML;
        });
        if (typeof cart.cartAction === 'function') cart.cartAction();
        return fetch('/cart.json').then(function (r) { return r.json(); });
      })
      .then(function (cartData) {
        if (cartData && typeof cartData.item_count !== 'undefined') {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = '(' + cartData.item_count + ')';
            } else {
              el.innerHTML = cartData.item_count > 100 ? '~' : cartData.item_count;
            }
          });
          var totalEl = document.querySelector('header-total-price');
          if (totalEl && typeof totalEl.updateTotal === 'function') totalEl.updateTotal(cartData);
          var freeShip = document.querySelector('free-ship-progress-bar');
          if (freeShip && typeof freeShip.init === 'function') freeShip.init(cartData.items_subtotal_price);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-add-open', cartData: cartData });
        }
        if (typeof cart.open === 'function') cart.open();
      })
      .catch(function (err) {
        console.error('cart-add-open failed:', err);
        window.location.href = trigger.getAttribute('href') || '/cart';
      })
      .finally(function () {
        trigger.classList.remove('loading');
      });
  }
})();
